import { useRef } from 'react'

import styled from 'styled-components'

import { Box } from 'app/components/design-system-components'
import { useOutsideAlerter } from 'app/components/design-system-components/Modal'
import AIAnalyzerHeader from 'app/components/display/smartdocs/AIAnalyzerHeader'
import ExplainerCopilot from 'app/components/display/smartdocs/ExplainerCopilot'
import UpgradeCTAFromSetting from 'app/components/display/smartdocs/upgradeCTAs/fromSetting'
import { history } from 'app/shared_components/router'

export const CopilotDropdownContainer = styled.div`
  min-width: 400px;
  position: absolute;
  top: 55px;
  padding: 24px 24px 16px;
  border-radius: 4px;
  border: 1px solid var(--Grey-300, #ccc);
  background: var(--White, #fff);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
  z-index: 100;
`

function CopilotDropdown(props) {
  const wrapperRef = useRef(null)

  const {
    showDropdown = false,
    closeAIDropdown,
    isAccountLite,
    copilotData = {},
    linkForApplication,
    isPremierAccount,
    copilotEnabledForTeam = false,
  } = props || {}
  useOutsideAlerter(wrapperRef, () => {
    closeAIDropdown && closeAIDropdown()
  })

  const onClickView = () => {
    history.push(linkForApplication)
  }

  const dontShowUpgradeCTA = isPremierAccount || copilotEnabledForTeam
  return (
    <>
      {showDropdown && (
        <CopilotDropdownContainer
          ref={wrapperRef}
          onClick={(event) => event.preventDefault()}
        >
          {!dontShowUpgradeCTA && <UpgradeCTAFromSetting width="100%" />}
          {dontShowUpgradeCTA && (
            <>
              <AIAnalyzerHeader
                isCopilot={true}
                withLearnMore={true}
                copilotSuggestions={1}
              />
              <Box mt={4}>
                <ExplainerCopilot
                  copilotData={copilotData}
                  onClickView={onClickView}
                  fromSummary={false}
                  isPremierAccount={isPremierAccount}
                />
              </Box>
            </>
          )}
        </CopilotDropdownContainer>
      )}
    </>
  )
}

export default CopilotDropdown
